import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import Courses from "../courses/index";
import Header from "./header";
/* import Osher from "./osher";
import Herramientas from "./herramientas"; */
import TeDelAlma from "./tedelalma";
import MiCamino from "./micamino";
import Contacto from "./contacto";
import LalaFooter from "../footer/footer";

import Testimonies from "./testimonies";
import Retiros from "./retiros";
import Robles from "./robles";

const Home = () => {
  useEffect(() => {
    // Fallback handler for Safari hash scroll (App level also handles this)
    const hash = window.location.hash;
    if (hash) {
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      
      if (isSafari) {
        // Additional delay to ensure everything is rendered
        setTimeout(() => {
          const element = document.querySelector(hash);
          if (element) {
            const navbar = document.querySelector('.navbar');
            const navbarHeight = navbar ? navbar.offsetHeight : 0;
            
            const rect = element.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const elementTop = rect.top + scrollTop;
            const scrollPosition = elementTop - navbarHeight;
            
            window.scrollTo({
              top: scrollPosition,
              behavior: 'smooth'
            });
          }
        }, 500); // Longer delay as fallback
      }
    }
  }, []);

  return (
    <Container fluid>
      <Header
        text='"Te acompaño a conectar con tu corazón, a elevar tu vibración y así abrirte al amor."'
        buttonText="Membresía"
      />
      <br></br>
      <br></br>
      <Courses />
      <br></br>
      <br></br>
      <br></br>
      <Testimonies />
      <TeDelAlma />
      <Retiros />
      <Robles />
      <br />
      <MiCamino />
      <Contacto />
      <LalaFooter />
    </Container>
  );
};

export default Home;
